import {PrimeIcons} from "primereact/api";
import {Card} from "primereact/card";
import {InputText} from "primereact/inputtext";
import {ToggleButton} from "primereact/togglebutton";
import {useState} from "react";
import {useTranslation} from "react-i18next";

import {DEFAULT_LAND_REGISTER_ATTRIBUTION, getLandRegisterAttributionsByStateCode} from "@reva/shared/land-register";

import drawIcon from "../../images/draw_icon.png";

/**
 * Land register attributions indexed by numeric state_code (1-16), with the fallback/default
 * attribution at index 0.
 */
export const landRegisterAttributions = () => {
    const byStateCode = getLandRegisterAttributionsByStateCode();
    return [
        DEFAULT_LAND_REGISTER_ATTRIBUTION,
        ...Array.from({length: 16}, (_, i) => byStateCode[String(i + 1).padStart(2, "0")]),
    ];
};

/**
 * Display Card with land registry meta.
 * @param {GeoRefAddress|undefined} addressMeta selected address meta
 * @param {string} [className] optional addition CSS classes
 */
export default function LandRegisterCard({addressMeta, className, onLandRegisterClick, onToggleMeasurement, area}) {
    const {t} = useTranslation();
    const [checked, setChecked] = useState(false);
    if (!addressMeta) return undefined;

    const currentYear = new Date().getFullYear();

    const attributions = landRegisterAttributions();

    const attribution = attributions[addressMeta.state_code] || attributions[0];
    // const api_url = attribution.api_url || attributions[0].api_url;
    const service_label = attribution.service_label || attributions[0].service_label;
    const service_license = attribution.service_license || attributions[0].service_license;
    const license_url = attribution.license_url || attributions[0].license_url;
    const license_Label = attribution.license_label || attributions[0].license_label;

    /*
      Amtliches Liegenschaftsinformationssystem Berlin, Senatsverwaltung für Stadtentwicklung und Wohnen,
      Geoportal Berlin / ALKIS Berlin, https://fbinter.stadt-berlin.de/fb/wms/senstadt/wmsk_alkis
      Datenlizenz Deutschland-Namensnennung-Version 2.0 - dl-de/by-2-0
      Lizenztext abrufbar unter www.govdata.de/dl-de/by-2-0
       */

    return (
        <div>
            <Card
                className={
                    "LandRegisterCard bg-surface-100 dark:bg-surface-700 hover:bg-surface-300 dark:hover:bg-surface-500" +
                    (className ? ` ${className}` : "")
                }
                onClick={onLandRegisterClick}
            >
                <div className="font-bold text-lg mb-2 pb-2 border-b">
                    <span className={`${PrimeIcons.MAP_MARKER} mr-2`} />
                    {t("landregister.title")}
                </div>
                <div className="LandRegisterRow mb-1">
                    <div className="LandRegisterLabel">{t("landregister.source")}:</div>
                    <div className="LandRegisterValue">
                        Amtliches Liegenschaftskatasterinformationssystem, {service_label} [{currentYear}]<br />
                        {service_license}
                    </div>
                </div>
                <div className="LandRegisterRow mb-2">
                    <div className="LandRegisterLabel">{t("landregister.license")}:</div>
                    <div className="LandRegisterValue">
                        <a target="_blank" rel="noreferrer" href={license_url}>
                            {license_Label}
                        </a>
                    </div>
                </div>
                <div className="LandRegisterRow mt-4 mb-1"></div>
                <div className="LandRegisterRow mb-1">
                    <div className="LandRegisterLabel" style={{padding: "0.5rem 0.5rem 0px 0px"}}>
                        <label htmlFor="area">{t("landregister.area")}:</label>
                    </div>
                    <div className="LandRegisterValue mr-2">
                        <div className="p-inputgroup">
                            <InputText id="area" lang={"de"} className="p-inputtext-sm" value={area || ""} disabled />
                            <span className="p-inputgroup-addon">m²</span>
                        </div>
                    </div>

                    <ToggleButton
                        onIcon={(options) => (
                            <img alt="draw on icon" style={{width: "1.2rem"}} src={drawIcon} {...options.iconProps} />
                        )}
                        onLabel=""
                        offIcon={(options) => (
                            <img alt="draw off icon" style={{width: "1.2rem"}} src={drawIcon} {...options.iconProps} />
                        )}
                        offLabel=""
                        onChange={(e) => {
                            onToggleMeasurement(e.value);
                            setChecked(e.value);
                        }}
                        checked={checked}
                    />
                </div>
            </Card>
        </div>
    );
}
